import { useState, useRef, useMemo, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {Row, Col, Form, Select, Input, Flex, Typography,
        Button, Upload, message, Space, 
        Modal, Spin,
        Card} from 'antd';
import { ArrowLeftOutlined, CloseCircleFilled,
        PlusOutlined, UploadOutlined,
        CheckOutlined, StopOutlined, MoreOutlined, CloseOutlined,
        EditOutlined,
        SaveOutlined} from '@ant-design/icons';
import defaultImageBtn from '../../assets/images/png_icon_action_default.png';
import styles from './Promotion.module.css';
import api from "../../API";
import Phone from "../../Components/Phone";
const { TextArea } = Input;
const checkLink = /https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)/;
const checkPhone = /^(03|05|07|08|09)\d{8}$/

const btnTypes = ['oa.open.url', 'oa.query.show', 'oa.query.hide', 'oa.open.sms', 'oa.open.phone']

const fieldList = [
    {
        key: 'table_key_1',
        value: 'table_value_1',
    },
    {
        key: 'table_key_2',
        value: 'table_value_2',
    },
    {
        key: 'table_key_3',
        value: 'table_value_3',
    },
    {
        key: 'table_key_4',
        value: 'table_value_4',
    },
    {
        key: 'table_key_5',
        value: 'table_value_5',
    }
]

const buttonList = [
    {
        title: 'button_1_title',
        icon: 'button_1_icon',
        type: 'button_1_type',
        payload: 'button_1_payload'
    },
    {
        title: 'button_2_title',
        icon: 'button_2_icon',
        type: 'button_2_type',
        payload: 'button_2_payload'
    },
    {
        title: 'button_3_title',
        icon: 'button_3_icon',
        type: 'button_3_type',
        payload: 'button_3_payload'
    },
    {
        title: 'button_4_title',
        icon: 'button_4_icon',
        type: 'button_4_type',
        payload: 'button_4_payload'
    }
]

const options1 = [
    {
        value: 'left',
        label: 'Trái',
    },
    {
        value: 'center',
        label: 'Giữa',
    },
    {
        value: 'right',
        label: 'Phải',
    }
]

function Promotion({tplType}) {
    const navigate = useNavigate();
    const location = useLocation();
    const detailInfo = location.state;
    const user = JSON.parse(localStorage.getItem('user'));
    const [form] = Form.useForm();
    const [selectedAlign1, setSelectedAlign1] = useState(0);
    const [selectedAlign2, setSelectedAlign2] = useState(0);
    const [selectedAlign3, setSelectedAlign3] = useState(0);
    const [banner, setBanner] = useState([]);
    const [titleMessage, setTitleMessage] =useState('');
    const [tableFields, setTableFields] = useState([{key: '', value: ''}])
    const [subTitleMessage1, setSubTitleMessage1] = useState('');
    const [subTitleMessage2, setSubTitleMessage2] = useState('');
    const [linkBtns, setlinkBtns] = useState([]);
    const [modal, setModal] = useState(false);
    const [modal1, setModal1] = useState({idModal: 0, idBtn: 0, open:false });
    const [loading, setLoading] = useState({spin: false, contact: false, templateBtn: false});
    const now = useRef((new Date()).toLocaleString('en-CA').replace(/[,.apm]/g,''));
    const renderTableList = useMemo(() => {
        const result = tableFields.map((_, indexField) => (
            <Flex align="flex-start" className={styles.valueTableItem} key={indexField} id={`${indexField}`}>
                <Form.Item
                    style={{ width: '50%'}}
                    name={fieldList[indexField].key}
                    rules={[{ required: true, message: 'The key cannot be empty'}]}>
                    <Input
                        maxLength={25}
                        style={{color: 'black'}}
                        onKeyUp={(e) => handleNameFields(e, indexField)} />
                </Form.Item>
                <Form.Item
                    style={{margin: '0 8px', width: '50%'}}
                    name={fieldList[indexField].value}
                    rules={[{ required: true, message: 'The value cannot be empty'}]}>
                    <Input
                        maxLength={100}
                        onKeyUp={e => handleValueFields(e, indexField)} />
                </Form.Item>
                <CloseCircleFilled onClick={() => handleRemoveFieldByID(indexField)}
                  className={`${styles.iconBlockValueTableItem} ${indexField === 0? styles.hideElem: ''}`}/>
            </Flex>
        ));
        return result;
    }, [tableFields.length])
    const renderBtns = useMemo(() => {
        const result1 = linkBtns.length !== 0 && linkBtns.map((btn, indexBtn)=>(
            <Space.Compact key={indexBtn} className={styles.linkBtn}>
                <Button icon={<MoreOutlined/>} onClick={() => handleBtnOpenModalByID(indexBtn)}>
                    {btn.title}
                </Button>
                <Button icon={<CloseOutlined />} onClick={() => handleRemoveBtn(indexBtn)}></Button>
            </Space.Compact>
        ))
        return result1;
    }, [linkBtns])
    const initialValues = {
        templateCode: `Template_Zalo_Follower_${(new Date()).toLocaleString('en-CA').replace(/[-:, .amp]/g,'')}`,
        header_title_alignment: 'left',
        header_text_alignment: 'left',
        footer_alignment: 'left',
        ...buttonList.reduce((prevArr, obj) => ({...prevArr, [obj.icon]: [], [obj.payload]: '', [obj.title]: '', [obj.type]: ''}),{}),
        ...fieldList.reduce((prevArr, obj) =>({...prevArr, [obj.key]: '', [obj.value]: ''}),{})
    }

    //When edit template
    useEffect(() => {
        if(detailInfo) {
            setLoading({...loading, spin: true});
            setBanner([{uid:'banner',  ...(JSON.parse(detailInfo.banner_url))}])
            setlinkBtns(buttonList.map((obj, i) =>  {
                let idType = btnTypes.findIndex(btnType => btnType === detailInfo[obj.type])
                let data = (idType === 0 || idType === 3 || idType === 4? JSON.parse(detailInfo[obj.payload]): detailInfo[obj.payload]);
                if(idType === 3 || idType === 4) data = {...data, phone_code: '0' + data.phone_code.slice(2)}
                form.setFieldsValue({
                    [obj.title]: detailInfo[obj.title],
                    [obj.icon]: detailInfo[obj.icon]? [{uid:obj.icon, ...JSON.parse(detailInfo[obj.icon])}]: [],
                    [obj.type]: detailInfo[obj.type],
                    [obj.payload]: data,
                })
                return { 
                    title: detailInfo[obj.title],
                    image: detailInfo[obj.icon]? [{uid:obj.icon, ...JSON.parse(detailInfo[obj.icon])}]: [{uid: 0, url: defaultImageBtn}],
                    data,
                    idType
                }
            }).filter(btn => btn.title))
            form.setFieldsValue({
                templateCode: detailInfo.templateCode,
                header_title_alignment: detailInfo.header_title_alignment,
                header_text_alignment: detailInfo.header_text_alignment,
                footer_alignment: detailInfo.footer_alignment,
                template_payload_lang: detailInfo.template_payload_lang,
                header_title_text: detailInfo.header_title_text,
                header_text: detailInfo.header_text,
                footer_text: detailInfo.footer_text,
                banner_url: [{uid: 'banner',  ...(JSON.parse(detailInfo.banner_url))}]
             })
            setTitleMessage(detailInfo.header_title_text);
            setSelectedAlign1(options1.findIndex(option => option.value === detailInfo.header_title_alignment));
            setSubTitleMessage1(detailInfo.header_text);
            setSelectedAlign2(options1.findIndex(option => option.value === detailInfo.header_text_alignment));
            setSubTitleMessage2(detailInfo.footer_text);
            setSelectedAlign3(options1.findIndex(option => option.value === detailInfo.footer_alignment));
            setTableFields(fieldList.map(obj => {
                form.setFieldsValue({
                    [obj.key]: detailInfo[obj.key],
                    [obj.value]: detailInfo[obj.value]
                })
                return {
                    key: detailInfo[obj.key],
                    value: detailInfo[obj.value]
                }
            }).filter(value => value.key || value.value));
            now.current =(new Date(detailInfo.createdDate)).toLocaleDateString('en-CA');
            setLoading({...loading, spin: false});
                
        }
    },[])

    //Clean up image banner
    useEffect(() => {
        return () => {
          banner[0] && URL.revokeObjectURL(banner[0].url); 
        }
    }, [banner[0]])
    
    //Clean up image icon
    useEffect(() => {
        return () => {
            linkBtns.forEach(btn => btn.image[0].uid && URL.revokeObjectURL(btn.image[0].url));
        }
    }, [linkBtns])

    function handleTitleChange(e){
        setTitleMessage(e.target.value)
    }

    function handleSubTitleChange1(e) {
        setSubTitleMessage1(e.target.value)
    }

    function handleSubTitleChange2(e) {
        setSubTitleMessage2(e.target.value)
    }

    function handleSelectedAlign1(selectedvalue) {
        var index= options1.findIndex(value => (value.value === selectedvalue));
        setSelectedAlign1(index)
    }

    function handleSelectedAlign2(selectedvalue) {
        var index= options1.findIndex(value => (value.value === selectedvalue));
        setSelectedAlign2(index)
    }

    function handleSelectedAlign3(selectedvalue) {
        var index= options1.findIndex(value => (value.value === selectedvalue));
        setSelectedAlign3(index)
    }

    function handleAddNewField() {
        setTableFields((prevArr) => [...prevArr, {
            key:'',
            value:''
        }])
    }

    function handleNameFields(e, indexField) {
        setTableFields((prevArr) => {
            const newArr = [...prevArr];
            newArr[indexField].key = e.target.value;
            return newArr;
        })
    }

    function handleValueFields(e, indexField) {
        setTableFields((prevArr) => {
            const newArr = [...prevArr];
            newArr[indexField].value = e.target.value;
            return newArr;
        }) 
    }

    function handleRemoveFieldByID(indexField) {
        for(var i = indexField; i < tableFields.length-1; i++) {
            form.setFieldsValue({
                [fieldList[i].key]: tableFields[i + 1].key ,
                [fieldList[i].value]: tableFields[i + 1].value
            })
        }

        form.resetFields([
            fieldList[tableFields.length-1].key, 
            fieldList[tableFields.length-1].value
        ])

        setTableFields(prevArr => {
            const newArr = [...prevArr];
            newArr.splice(indexField,1);
            return newArr;
        })
    }
      
    function beforeUploadImage(file) {
        return new Promise((resolve, reject) => {
            const isSizeValid = file.size / 1024 / 1024 <= 1;
            if (!isSizeValid) {
                message.error('Image must be smaller than 1MB!');
                reject(false);
            }
            resolve(true);
        });
    }; 

    async function customRequestImage({ file, onSuccess, onError }) {
        try {
            await beforeUploadImage(file); // Kiểm tra điều kiện trước khi tải lên
            message.success("Photo uploaded successfully")
            onSuccess('ok');
        } catch (error) {
            // Xử lý lỗi từ beforeUploadImage
            onError('err');
        }
    }

    function handleImageBanner({file}) {
        if (file.status === 'done') {
                form.setFieldValue('banner_url', [{
                    uid: file.uid, 
                    name: file.name,
                    file: file.originFileObj,
                    url: URL.createObjectURL(file.originFileObj),
                }]);
                setBanner([{
                    uid: file.uid, 
                    name: file.name,
                    file: file.originFileObj,
                    url: URL.createObjectURL(file.originFileObj),
                }]);   
        } else if(file.status === 'error') {
            form.setFieldValue('banner_url', banner);
        } else return;
    };

    function handleRemoveImageBanner(file) {
        setBanner([]);
        return true;
    }

    function handleImageIconBtn({file}) {
        if (file.status === 'done') {
            form.setFieldValue(buttonList[modal1.idModal].icon, [{
                    uid: file.uid, 
                    name: file.name,
                    url: URL.createObjectURL(file.originFileObj),
                    file: file.originFileObj,
                }]    
            )
        }
        if(file.status === 'error') {
            var image = [];
            if(linkBtns[modal1.idModal]) image = (linkBtns[modal1.idModal].image[0].uid? linkBtns[modal1.idModal].image: [])
            form.setFieldValue(buttonList[modal1.idModal].icon, image);
        }
    }
    
    function showModal1(){
        setModal(true);
    };

    function showModal2(idBtn){
        setModal(false);
        setModal1({
            idModal: linkBtns.length,
            idBtn,
            open: true
        });
    };

    function handleOk(e) {
        if(form.getFieldValue(buttonList[modal1.idModal].title) &&  form.getFieldValue(buttonList[modal1.idModal].payload)){
            let ok = true;
            if(modal1.idBtn === 0) {
                if(!checkLink.test(form.getFieldValue([buttonList[modal1.idModal].payload, 'url']))) ok = false;
            } else if(modal1.idBtn === 3 || modal1.idBtn === 4){
                if(!checkPhone.test(form.getFieldValue([buttonList[modal1.idModal].payload, 'phone_code']))) ok = false;
            }
            if(ok){    
                var image = form.getFieldValue(buttonList[modal1.idModal].icon);
                if(!image || !image.length) {
                    image = [{uid: 0, url: defaultImageBtn}];
                }
                setlinkBtns(prevArr => [
                    ...prevArr,
                    {
                        title: form.getFieldValue(buttonList[modal1.idModal].title),
                        image,
                        data: form.getFieldValue(buttonList[modal1.idModal].payload),
                        idType: modal1.idBtn
                    }    
                ])
                form.setFieldValue(buttonList[modal1.idModal].type, btnTypes[modal1.idBtn]);
                setModal1({...modal1, open: false});
            }
        } else {
            if(!form.getFieldValue(buttonList[modal1.idModal].title)) 
                form.setFields([{
                    name: buttonList[modal1.idModal].title,
                    errors: ['Bạn chưa nhập tiêu đề']
                }])
            
            if(!form.getFieldValue([buttonList[modal1.idModal].payload, 'url']) && modal1.idBtn ===0)
                form.setFields([{
                    name: [buttonList[modal1.idModal].payload, 'url'],
                    errors: ['Bạn chưa nhập link']
                }])
            
            if(!form.getFieldValue(buttonList[modal1.idModal].payload) && (modal1.idBtn === 1 || modal1.idBtn === 2))
                form.setFields([{
                    name: buttonList[modal1.idModal].payload,
                    errors: ['Bạn chưa nhập tin nhắn']
                }])

            if(modal1.idBtn === 3){
                if(!form.getFieldValue(buttonList[modal1.idModal].payload).content)
                    form.setFields([{
                        name: [buttonList[modal1.idModal].payload, 'content'],
                        errors: ['Bạn chưa nhập tin nhắn sms']
                    }])
                if(!form.getFieldValue(buttonList[modal1.idModal].payload).phone_code)
                    form.setFields([{
                        name: [buttonList[modal1.idModal].payload, 'phone_code'],
                        errors: ['Bạn chưa nhập số điện thoại']
                    }])
            }

            if(!form.getFieldValue(buttonList[modal1.idModal].payload) && modal1.idBtn === 4)
                form.setFields([{
                    name: [buttonList[modal1.idModal].payload, 'phone_code'],
                    errors: ['Bạn chưa nhập số điện thoại']
                }])

        }
    };

    function handleBtnOpenModalByID(indexBtn){
        setModal1({
            idModal: indexBtn, 
            idBtn: linkBtns[indexBtn].idType,
            open: true
        });
    }

    function handleUpdateDataInModal(e){
        if(form.getFieldValue(buttonList[modal1.idModal].title) && form.getFieldValue(buttonList[modal1.idModal].payload)){
            let ok = true;
            if(modal1.idBtn === 0) {
                if(!checkLink.test(form.getFieldValue([buttonList[modal1.idModal].payload, 'url']))) ok = false;
            } else if(modal1.idBtn === 3 || modal1.idBtn === 4){
                if(!checkPhone.test(form.getFieldValue([buttonList[modal1.idModal].payload, 'phone_code']))) ok = false;
            }
            if(ok){        
                var image = form.getFieldValue(buttonList[modal1.idModal].icon);
                if(!image.length) {
                    image = [{uid: 0, url: defaultImageBtn}];
                }
                setlinkBtns(prevArr => {
                    const newArr = [...prevArr];
                    newArr[modal1.idModal] = {
                        ...newArr[modal1.idModal],
                        title: form.getFieldValue(buttonList[modal1.idModal].title),
                        image,
                        data: form.getFieldValue(buttonList[modal1.idModal].payload)
                    }
                    return newArr;
                })
                setModal1({...modal1, open: false});
            }
        } 
    }

    function handleRemoveBtn(indexBtn){
        for(var i = indexBtn; i < linkBtns.length-1; i++) {
            form.setFields([
                { name: buttonList[i].title, value: linkBtns[i + 1].title },
                { name: buttonList[i].icon, value: (linkBtns[i + 1].image[0].uid? linkBtns[i + 1].image: [])},
                { name: buttonList[i].payload, value: linkBtns[i + 1].data },
                { name: buttonList[i].type, value: btnTypes[linkBtns[i + 1].idType]},
            ]);
        }

        form.resetFields([
            buttonList[linkBtns.length-1].title, 
            buttonList[linkBtns.length-1].icon, 
            buttonList[linkBtns.length-1].payload,
            buttonList[linkBtns.length-1].type
        ])

        setlinkBtns(prevArr => {
            const newArr = [...prevArr];
            newArr.splice(indexBtn,1);
            return newArr;
        })
    }

    function handleCancel(e) {
        setModal(false);
    };
        
    function handleCancel1(e) {
        form.resetFields([
            buttonList[modal1.idModal].title, 
            buttonList[modal1.idModal].icon, 
            [buttonList[modal1.idModal].payload, 'url'],
            [buttonList[modal1.idModal].payload, 'phone_code'],
            [buttonList[modal1.idModal].payload, 'content'],
            buttonList[modal1.idModal].payload,
            buttonList[modal1.idModal].type,
        ])
        if(linkBtns.length > modal1.idModal)
        form.setFieldsValue({
            [buttonList[modal1.idModal].title]: linkBtns[modal1.idModal].title,
            [buttonList[modal1.idModal].icon]: (linkBtns[modal1.idModal].image[0].uid? linkBtns[modal1.idModal].image: []),
            [buttonList[modal1.idModal].payload]: linkBtns[modal1.idModal].data,
            [buttonList[modal1.idModal].type]: btnTypes[modal1.idBtn],
        })
        setModal1({...modal1, open: false});
    };

    async function handleSubmit(values) {
        let resultUploadImgs;
        try {
            setLoading({...loading, templateBtn: true});
            let bannerObj =  form.getFieldValue('banner_url')[0];
            let index = bannerObj.file? 1: 0;
            let filesToUpload = [];
            let filesToRemove = [];
            if(index) {
                filesToUpload.push(bannerObj.file); 
                if(detailInfo) filesToRemove.push(JSON.parse(detailInfo.banner_url).url.split("/").pop())
            }
            buttonList.forEach(btn1 => {
                let img = form.getFieldValue(btn1.icon)[0];
                let prevIcon = detailInfo?.[btn1.icon] && JSON.parse(detailInfo[btn1.icon])
                if(prevIcon && buttonList.every(btn2 => form.getFieldValue(btn2.icon)[0]?.url !== prevIcon.url))
                    filesToRemove.push(prevIcon.url.split("/").pop());
                if(img?.file) filesToUpload.push(img.file);  
            })
            if(filesToUpload.length) resultUploadImgs = await api.uploadFiles(filesToUpload);
            const btnIconAndPayload = buttonList.reduce((prevResult, value) => {
                let payload = form.getFieldValue(value.payload);
                let img = form.getFieldValue(value.icon)[0];
                if (typeof payload !== 'string') {
                    payload = payload.url ? JSON.stringify(payload) : JSON.stringify({
                        ...payload,
                        phone_code: '84' + payload.phone_code.substring(1)
                    });
                }
                return {
                    ...prevResult,
                    [value.icon]: img? (img.file? JSON.stringify(resultUploadImgs[index++]): JSON.stringify({name: img.name, url: img.url})):'',
                    [value.payload]: payload,
                };
            },{})
            const promotionTemplateObj = {
                id: 1,
                templateType: tplType,
                ...form.getFieldsValue(true),
                banner_url: bannerObj.file? JSON.stringify(resultUploadImgs[0]): detailInfo.banner_url,
                ...btnIconAndPayload,
                createdDate: now.current,
                lastUpdated: (new Date()).toLocaleString('en-CA').replace(/[,.apm]/g,''),
                userId: user?.userId
            }
            let response = detailInfo? 
                await api.update_templateById(detailInfo.id, promotionTemplateObj, tplType):
                await api.create_new_template(promotionTemplateObj, tplType);
            if(filesToRemove.length) await api.deleteFiles(filesToRemove);
            message.success(response.message);
            navigate('/template/promotions');
        } catch (error) {
           message.error(error.message);
           if(resultUploadImgs) api.deleteFiles(resultUploadImgs.map(({url}) => url.split("/").pop())).catch(err => message.error(err.message));
        } finally {
            setLoading({...loading, templateBtn: false});
        }
    };

    return (
    <Card 
        style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title={
        <Space>
            <Link to="/template/promotions">
                    <Button style={{width: 50}} icon={<ArrowLeftOutlined />}></Button>
            </Link>
            <Typography.Title level={5} style={{margin:0}}>{detailInfo? 'Update': 'Create new'} promotion</Typography.Title>
        </Space>
        }
        loading={loading.spin}
    >
        <Form name="promotionform" label="promotion form" layout='vertical' form={form} initialValues={initialValues} onFinish={handleSubmit}>
            <Row gutter={[0,16]}>
                <Col className="gutter-row" xxl={12} xl={12} lg={24} sm={24} xs={24}>
                    <div className={styles.form}>  
                        <Form.Item label='Template Code' 
                                    name='templateCode'  
                                    rules={[
                                    {
                                        required: true,
                                        message: 'The template code cannot be empty'
                                    },
                                    ]}>
                            <Input type='text' maxLength={100}/>
                        </Form.Item>             
                        <Form.Item label='Image'
                                name='banner_url'
                                valuePropName= 'fileList'
                                getValueFromEvent= {(e) => {
                                    if (Array.isArray(e)) {
                                    return e;
                                    }
                                    return e && e.fileList;
                                    }}
                                rules={[{ 
                                    required: true,
                                    message: 'The image cannot be empty'
                                }]}
                                style={{textAlign: 'left'}}>
                            <Upload
                                name='uploadbanner'
                                accept="image/jpeg,image/png"
                                customRequest={customRequestImage}
                                onChange={handleImageBanner}
                                onRemove={handleRemoveImageBanner}
                                maxCount={1}
                            >
                                <Button icon={<UploadOutlined />}>
                                    Click to Upload
                                </Button>
                            </Upload>
                        </Form.Item>
                        <div className={styles.headerTitle} style={{marginBottom: 40}}>
                            <Form.Item  name='header_title_alignment'
                                        className={styles.alignHeaderTitle}>
                                <Select
                                    onChange={handleSelectedAlign1}
                                    options={options1}/>
                            </Form.Item>
                            <Form.Item  label='Header' 
                                        name='header_title_text'  
                                        rules={[{ required: true, message: 'The title cannot be empty'}]}>
                                <TextArea type='text' 
                                        showCount 
                                        rows={1}
                                        maxLength={100}
                                        onKeyUp={handleTitleChange}/>
                            </Form.Item>
                        </div>
                        <div className={styles.subTitle}>
                            <Form.Item  name='header_text_alignment' 
                                        className={styles.alignSubTitle}>
                                <Select
                                    onChange={handleSelectedAlign2}
                                    options={options1}
                                />
                            </Form.Item>
                            <Form.Item  label='Text Header'  
                                        name='header_text'
                                        rules={[{ required: true, message: 'The subtitle cannot be empty'}]}>
                                <TextArea type='text' 
                                        showCount
                                        rows={3}
                                        maxLength={100}
                                        onKeyUp={handleSubTitleChange1}/>
                            </Form.Item>
                        </div>
                        <Form.Item  label='Table Values'
                                    style={{margin: 0}}
                                    required>
                            <div>
                                <Flex align='center' style={{marginBottom: 5}}>
                                    <div style={{width: '50%'}}>Keys</div>
                                    <div style={{width: '50%'}}>Values</div>
                                </Flex>
                                {renderTableList}
                                <Form.Item className={`${(tableFields.length === 5) ? styles.hideElem: ''}`}>
                                    <Button onClick={handleAddNewField}  
                                            icon={<PlusOutlined />} >
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form.Item>
                        <div className={styles.subTitle}>
                            <Form.Item  name='footer_alignment' 
                                        className={styles.alignSubTitle}>
                                <Select
                                    onChange={handleSelectedAlign3}
                                    options={options1}
                                />
                            </Form.Item>
                            <Form.Item  label='Text Footer'
                                        name='footer_text'
                                        rules={[{ required: true, message: 'The subtitle cannot be empty'}]}>
                                <TextArea type='text' 
                                        showCount 
                                        rows={3}
                                        maxLength={1000}
                                        onKeyUp={handleSubTitleChange2}/>
                            </Form.Item>
                        </div>
                        <Form.Item label='Buttons'>
                            <div>
                                <Modal
                                    open={modal}
                                    title={<div className={styles.titleModal}>Set up button</div>}
                                    onCancel={handleCancel}
                                    footer={<div style={{borderBottom: '1px solid #ccc'}}></div>}
                                    width={802}
                                    closable={false}>
                                    <Flex className={styles.btnsModal} justify='space-between' align='center' gap='large' wrap> {
                                        ['Open URL','Query Show', 'Query Hide', 'Query Sms', 'Open Phone'].map(
                                            (val, i) => <Button className={styles.btnModal} onClick={() => showModal2(i)} key={i}>{val}</Button>)
                                    }</Flex>
                                </Modal>

                                <Modal
                                    open={modal1.open}
                                    onOk={modal1.idModal === linkBtns.length? handleOk: handleUpdateDataInModal}
                                    title={<div className={styles.titleModal}>{modal1.idModal == linkBtns.length? 'New Button': `Button ${modal1.idModal+1}`}</div>}
                                    onCancel={handleCancel1}
                                    cancelText='Cancel'
                                    cancelButtonProps={{icon:<StopOutlined/>}}
                                    okText={modal1.idModal == linkBtns.length? 'Create new': 'Update'}
                                    okButtonProps={{icon: <CheckOutlined/>}}
                                    width={802}
                                    closable={false}>
                                    <div style={{borderBottom: '1px solid #ccc'}}>
                                        <Form.Item  label='Title'
                                                    name={buttonList[modal1.idModal].title}
                                                    labelAlign='left'
                                                    labelCol={{span: 3}}
                                                    required>
                                            <Input maxLength={35} showCount onChange={e => {
                                                if(e.target.value.length === 0) 
                                                    form.setFields([{
                                                        name: buttonList[modal1.idModal].title,
                                                        errors: ['The title cannot be empty']
                                                    }])
                                                else form.setFields([{
                                                        name: buttonList[modal1.idModal].title,
                                                        errors: null
                                                    }])}}/>
                                        </Form.Item>
                                        <Form.Item  label='Image'
                                                    name={buttonList[modal1.idModal].icon}
                                                    labelCol={{span: 3}}
                                                    labelAlign='left'
                                                    valuePropName= 'fileList'
                                                    getValueFromEvent= {(e) => {
                                                        if (Array.isArray(e)) {
                                                        return e;
                                                        }
                                                        return e && e.fileList;
                                                    }}>
                                            <Upload
                                                name='uploadfileimgbtn'
                                                accept="image/jpeg,image/png"
                                                customRequest={customRequestImage}
                                                onChange={handleImageIconBtn}
                                                maxCount={1}
                                            >
                                                <Button icon={<UploadOutlined />}>
                                                    Click to Upload
                                                </Button>
                                            </Upload>
                                        </Form.Item>
                                        <Form.Item  label='Link URL'
                                                    hidden={modal1.idBtn !== 0}
                                                    name={[buttonList[modal1.idModal].payload,'url']}
                                                    labelAlign='left'
                                                    labelCol={{span: 3}}
                                                    required>        
                                            <Input onChange={e => {
                                                if(e.target.value.length === 0) 
                                                    form.setFields([{
                                                        name: [buttonList[modal1.idModal].payload,'url'],
                                                        errors: ['The link cannot be empty']
                                                    }])
                                                else if(!checkLink.test(form.getFieldValue([buttonList[modal1.idModal].payload,'url'])))
                                                    form.setFields([{
                                                        name: [buttonList[modal1.idModal].payload,'url'],
                                                        errors: ['Invalid link']
                                                    }])
                                                else form.setFields([{
                                                        name: [buttonList[modal1.idModal].payload,'url'],
                                                        errors: null
                                                    }])
                                                }}/>
                                        </Form.Item>
                                        <Form.Item  label='Message'
                                                    hidden={modal1.idBtn !== 1 && modal1.idBtn !== 2}
                                                    name={buttonList[modal1.idModal].payload}
                                                    labelAlign='left'
                                                    labelCol={{span: 3}}
                                                    required>
                                            <Input maxLength={1000} showCount onChange={e => {
                                                if(e.target.value.length === 0) 
                                                    form.setFields([{
                                                        name: buttonList[modal1.idModal].payload,
                                                        errors: ['The message cannot be empty']
                                                    }])
                                                else form.setFields([{
                                                        name: buttonList[modal1.idModal].payload,
                                                        errors: null
                                                    }])
                                                }}/>
                                        </Form.Item>
                                        <Form.Item  label='SMS Message'
                                                    hidden={modal1.idBtn !== 3}
                                                    name={[buttonList[modal1.idModal].payload, 'content']}
                                                    labelAlign='left'
                                                    labelCol={{span: 4}}
                                                    required>
                                            <Input maxLength={160} showCount onChange={e => {
                                                if(e.target.value.length === 0) 
                                                    form.setFields([{
                                                        name: [buttonList[modal1.idModal].payload, 'content'],
                                                        errors: ['The message cannot be empty']
                                                    }])
                                                else form.setFields([{
                                                        name: [buttonList[modal1.idModal].payload, 'content'],
                                                        errors: null
                                                    }])
                                                }}/>
                                        </Form.Item>
                                        <Form.Item  label='Phone'
                                                    hidden={modal1.idBtn !== 3 && modal1.idBtn !== 4}
                                                    name={[buttonList[modal1.idModal].payload, 'phone_code']}
                                                    labelAlign='left'
                                                    labelCol={{span: 4}}
                                                    required>
                                            <Input maxLength={10} addonBefore='+84' onChange={e => {
                                                if(e.target.value.length === 0) 
                                                    form.setFields([{
                                                        name: [buttonList[modal1.idModal].payload, 'phone_code'],
                                                        errors: ['The phone number cannot be empty']
                                                    }])
                                                else  if(!checkPhone.test(form.getFieldValue([buttonList[modal1.idModal].payload, 'phone_code'])))
                                                    form.setFields([{
                                                        name: [buttonList[modal1.idModal].payload, 'phone_code'],
                                                        errors: ['Invalid phone number']
                                                    }])
                                                else form.setFields([{
                                                        name: [buttonList[modal1.idModal].payload, 'phone_code'],
                                                        errors: null
                                                    }])
                                                }}/>
                                        </Form.Item>
                                        <Form.Item hidden name={buttonList[modal1.idModal].type}>
                                            <Input/>
                                        </Form.Item>
                                    </div>
                                </Modal>
                                
                                <Space wrap={true}>
                                    {renderBtns}
                                    <Button icon={<PlusOutlined/>} onClick={showModal1} className={`${linkBtns.length === 4 && styles.hideElem}`}>
                                        {!linkBtns.length && 'Add new'}
                                    </Button>
                                </Space>
                            </div>
                        </Form.Item>
                    </div>
                </Col>
                <Col className="gutter-row" xxl={12} xl={12} lg={24} sm={24} xs={24}>
                    <Row>
                        <Col span={24}>
                            <div className={styles.title2}>Preview</div>                   
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Phone  
                                phoneProps={{
                                    imageURL: banner[0] && banner[0].url,
                                    header: {iconType: 'promotionIcon' ,content: "TIN TRUYỀN THÔNG"},
                                    msgType: 'template',
                                    buttons: linkBtns,
                                    table: tableFields,
                                    headerMessage: {content: titleMessage, align: options1[selectedAlign1].value},
                                    subHeaderMessage: {content: subTitleMessage1, align: options1[selectedAlign2].value},
                                    subFooterMessage: {content: subTitleMessage2, align:options1[selectedAlign3].value}
                                }}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row> 
            <Row className={styles.button}>
                <Col span={24} style={{textAlign: 'left'}}>
                    <Form.Item noStyle>
                        <Button type="primary" htmlType="submit" loading={loading.templateBtn} icon={detailInfo? <EditOutlined/>: <SaveOutlined/>}>
                            {detailInfo? 'Update Template': 'Save to Draft'}
                        </Button>
                    </Form.Item>
                </Col>
            </Row> 
        </Form>
    </Card>
    );
}
export default Promotion;